import { render, staticRenderFns } from "./BillsPending.vue?vue&type=template&id=7f531379"
import script from "./BillsPending.vue?vue&type=script&lang=ts"
export * from "./BillsPending.vue?vue&type=script&lang=ts"
import style0 from "./BillsPending.vue?vue&type=style&index=0&id=7f531379&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports